import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { MatTabsModule } from '@angular/material/tabs';
import { TranslocoDirective } from '@jsverse/transloco';

/**A Home tab. Category tabs carry their data-driven `label` as-is; a tab
 * whose text is the app's own (Favorites) carries a translation `labelKey`
 * instead (EXT-5702), translated when rendered so it follows a language
 * change without the parent recomputing anything.
 */
export type HomeTab = {
  id: string;
  label?: string;
  labelKey?: string;
};

@Component({
  selector: 'app-home-tabs',
  templateUrl: './home-tabs.component.html',
  styleUrl: './home-tabs.component.scss',
  imports: [MatTabsModule, TranslocoDirective],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomeTabsComponent {
  public tabs = input.required<Array<HomeTab>>();
  public activeId = input.required<string>();
  public tabSelected = output<string>();

  protected select(id: string): void {
    this.tabSelected.emit(id);
  }
}
